<template>
  <div class="contract-management">
    <div class="contract-management-top">
      <span>合约管理</span>
    </div>
    <div class="contract-management-bottom">
      <div class="search-criteria">
        <div class="search-criteria-l">
          <el-select v-model="provincesName" clearable placeholder="请选择省份" @change="provincesChange">
            <el-option
              v-for="item in provincesList"
              :key="item.province"
              :label="item.province"
              :value="item.province">
            </el-option>
          </el-select>
          <el-select v-model="cityName" clearable placeholder="请选择城市" @change="cityChange">
            <el-option
              v-for="item in cityList"
              :key="item.city"
              :label="item.city"
              :value="item.city">
            </el-option>
          </el-select>
          <el-select v-model="stationName" clearable placeholder="请选择场站" @change="stationChange">
            <el-option
              v-for="item in stationList"
              :key="item.station_id"
              :label="item.station_name"
              :value="item.station_id">
            </el-option>
          </el-select>
          <el-select v-model="contractType" clearable placeholder="请选择合约类型">
            <el-option
              v-for="item in contractTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="contractName" clearable placeholder="请输入合约名称"></el-input>
          <el-button class="search" @click="searchClick()">查询</el-button>
          <div style="clear:both;"></div>
        </div>
        <div class="search-criteria-r">
          <el-button class="newly-build" @click="newlyBuildClick(1)" :disabled="addPrivilege==1" :class="[addPrivilege==1?'active':'']">新建 +</el-button>
        </div>
        <div style="clear:both;"></div>
      </div>
      <div class="contract-table">
        <el-table
          :data="yemiandata"
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          border
          style="width: 100%">
          <el-table-column
            prop="name"
            label="合约"
            width="">
            <template slot-scope="scope">{{ scope.row.name | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="city"
            label="城市"
            width="80">
          </el-table-column>
          <el-table-column
            prop="station_name"
            label="场站">
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.type==1">月结</span>
              <span v-else-if="scope.row.type==2">电费</span>
              <span v-else-if="scope.row.type==3">场地租赁</span>
              <span v-else-if="scope.row.type==4">收入</span>
              <span v-else-if="scope.row.type==5">支出</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="start_date"
            label="开始日期"
            width="85">
          </el-table-column>
          <el-table-column
            prop="end_date"
            label="结束日期"
            width="85">
          </el-table-column>
          <el-table-column
            prop="filename"
            label="文件名"
            width="">
          </el-table-column>
          <el-table-column
            prop="created_user"
            label="创建用户"
            width="100">
          </el-table-column>
          <el-table-column
            prop="created_time"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="210">
            <template slot-scope="scope">
              <a :href="scope.row.fileurl" target="_blank" class="table-see">查看</a>
              <!-- <el-button class="table-btn table-see" v-else-if="seePrivilege==1" :disabled="seePrivilege==1" :class="[seePrivilege==1?'active':'']">查看</el-button> -->
              <el-button class="table-btn table-edit" @click="editClick(scope.row,2)" :disabled="editPrivilege==1" :class="[editPrivilege==1?'active':'']">编辑</el-button>
              <el-button class="table-btn table-delete" @click="deleteClick(scope.row)" :disabled="deletePrivilege==1" :class="[deletePrivilege==1?'active':'']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="currentChange"
        :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <!-- 新建编辑弹框 -->
    <el-dialog
		:visible.sync="newContractDialog"
    customClass="new-contract-dialog"
    @close="cancelClick"
		width="934px"
    :close-on-click-modal="false"
		>
      <p class="title">{{contractTitle}}</p>
      <div class="line"></div>
      <div class="contract-content">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <div class="content-left">
                <div class="details">
                  <div class="details-title title-province">
                    <span class="star">*</span>
                    <span>省份：</span>
                  </div>
                  <div class="details-r details-province">
                    <el-select v-model="provinceD" clearable :disabled="btnNumber==2" placeholder="请选择省份" @change="provinceDChange">
                      <el-option
                        v-for="item in provincesList"
                        :key="item.province"
                        :label="item.province"
                        :value="item.province"
                      ></el-option>
                    </el-select>
                    <el-select v-model="cityD" clearable :disabled="btnNumber==2" placeholder="请选择城市" @change="cityDChange">
                      <el-option
                        v-for="item in cityDList"
                        :key="item.city"
                        :label="item.city"
                        :value="item.city"
                      ></el-option>
                    </el-select>
                    <el-select v-model="stationD" clearable :disabled="btnNumber==2" placeholder="请选择场站" @change="stationDChange">
                      <el-option
                        v-for="item in stationDList"
                        :key="item.station_id"
                        :label="item.station_name"
                        :value="item.station_id"
                      ></el-option>
                    </el-select>
                    <div style="clear:both;"></div>
                  </div>
                </div>
                <!-- <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>场站：</span>
                  </div>
                  <div class="details-r">
                    <el-select v-model="stationD" :disabled="btnNumber==2" placeholder="请选择场站" @change="stationDChange">
                      <el-option
                        v-for="item in stationDList"
                        :key="item.station_id"
                        :label="item.station_name"
                        :value="item.station_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div> -->
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>合约名称：</span>
                  </div>
                  <div class="details-r">
                    <el-input v-model="contractDName" clearable placeholder="请输入合约名称"></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>开始日期：</span>
                  </div>
                  <div class="details-r2">
                    <el-date-picker
                      v-model="startTimeD"
                      type="date"
                      placeholder="选择日期"
                      style="width:100%">
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="11">
            <div class="grid-content bg-purple-light">
              <div class="content-right">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>合约类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select v-model="contractDType" clearable placeholder="请选择合约类型">
                      <el-option
                        v-for="item in contractTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title upload-title">
                    <span class="star">*</span>
                    <span>合约文件：</span>
                  </div>
                  <div class="details-r2">
                    <div class="upload-text">
                      <el-upload
                        class="upload-demo"
                        :action="global"
                        :headers="headers"
                        :show-file-list="false"
                        :auto-upload="false"
                        ref="upload"
                        :data="resData"
                        :on-change="fileBroadcastChange"
                        :onSuccess="uploadSuccess"
                        >
                          <el-button size="small" type="primary" class="file-btn">选择文件</el-button>
                      </el-upload>
                      <span class="file-name">{{ fileTitle }}</span>
                      <div style="clear:both;"></div>
                    </div>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>结束日期：</span>
                  </div>
                  <div class="details-r">
                    <el-date-picker
                      v-model="endTimeD"
                      type="date"
                      placeholder="选择日期"
                      :picker-options="pickerOptions1"
                      style="width:100%">
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="button">
          <el-button class="button-cancel" @click="cancelClick()">取消</el-button>
          <el-button class="button-confirm" v-if="btnNumber==1" @click="addConfirmClick()">确认</el-button>
          <el-button class="button-confirm" v-if="btnNumber==2" @click="editConfirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { parseDateFilter } from "@/filters";
export default {
  data() {
    return {
      newContractDialog:false,
      contractTitle:"新建合约",
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < this.startTimeD;
        }
      },
      provincesList:[],
      provincesName:"",
      cityList:[],
      cityName:"",
      stationList:[],
      stationName:"",
      contractTypeList:[
        {
          value:'1',
          label:'月结',
        },
        {
          value:'2',
          label:'电费',
        },
        {
          value:'3',
          label:'场地租赁',
        },
        {
          value:'4',
          label:'收入',
        },
        {
          value:'5',
          label:'支出',
        },
      ],
      contractType:"",
      contractName:"",
      global:"https://service-web.szdreamerstech.com//api.php/DeviceManage/index",
      resData:{},
      headers:{},
      fileName:"",
      file:{},
      fileTitle:"未选择任何文件",
      cityDList:[],
      cityD:"",
      provinceD:'',
      stationD:"",
      stationDList:[],
      contractDName:'',
      endTimeD:"",
      startTimeD:"",
      contractDType:"",
      btnNumber:0,
      editId:"",
      addPrivilege:1,//新建
      editPrivilege:1,//编辑
      seePrivilege:1,//查看合约
      deletePrivilege:1,//删除
    };
  },
  mounted() {
    this.$nextTick(function() {
      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "场站管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "合约管理"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "编辑"){
                  this.editPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "新建"){
                  this.addPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "删除"){
                  this.deletePrivilege = 0;
                }
                //  else if(role[i].chlid[j].method[m].method_name == "查看合约"){
                //   this.seePrivilege = 0;
                // }
              }
            }
          }
        }
      }

      this.getProvinces();
      this.getDataList();
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(province,city,stationId,type,name){
      this.headers = {
        "Content-Type": "multipart/form-data"
      };
      if(province == undefined){
        province = "";
      }
      if(city == undefined){
        city = "";
      }
      if(stationId == undefined){
        stationId = "";
      }
      if(type == undefined){
        type = "";
      }
      if(name == undefined){
        name = "";
      }
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"getContracts",
          city:city,
          station_id:stationId,
          type:type,
          name:name,
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Contract/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.tableData = su.data.list;
                this.totalNum = this.tableData.length;
                if(this.totalNum > 10){
                  // debugger
                  this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                } else {
                  this.yemiandata=this.tableData;
                }
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    getProvinces(){
        let params = {
            uid: localStorage.getItem("uid"),
            token: localStorage.getItem("token"),
        };
        this.$api({
            method: "post",
            url: "/api.php/Currency/get_provinces",
            data: params,
            transformRequest: [
            data => {
                let ret = "";
                for (let it in data) {
                ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
                }
                return ret;
            }
            ]
        })
            .then(su => {
                if(su.data.code == 1){
                    this.provincesList = su.data.list;
                } else if(su.data.code == 300) {
                    localStorage.clear(); 
                    this.$router.push('/login');
                    this.$message.warning(su.data.message);
                } else if (su.data.code == 900)  {
              } else {
                    this.$message.warning(su.data.message);
                }
            })
            .catch(err => {
        });
    },
    provincesChange(province){
      this.cityName = "";
      this.cityList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cityList = su.data.list;
              } else if(su.data.code == 300) {
                  localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else if (su.data.code == -1)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cityChange(city){
      this.stationList = [];
      this.stationName = "";
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.stationList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else if (su.data.code == -1)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    stationChange(stationId){
      this.stationName = stationId;
    },
    searchClick(){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList(this.provincesName,this.cityName,this.stationName,this.contractType,this.contractName);
    },
    deleteClick(row){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"deleteContract",
          id:row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Contract/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList(this.provincesName,this.cityName,this.stationName,this.contractType,this.contractName);
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    newlyBuildClick(num){
      this.btnNumber = num;
      this.newContractDialog = true;
      this.contractTitle = "新建合约";
      this.getProvinces();
    },
    cancelClick(){
      this.newContractDialog = false;
      this.provinceD = "";
      this.cityD = "";
      this.cityDList = [];
      this.stationD = "";
      this.stationDList = [];
      this.contractDName = "";
      this.contractDType = "";
      this.startTimeD = "";
      this.endTimeD = "";
      this.file = {};
      this.fileTitle = "未选择任何文件";
    },
    fileBroadcastChange(file, fileList){
      // debugger
      this.file = file.raw;
      this.fileName = file.name;
      this.fileTitle = file.name;
    },
    uploadSuccess(res, file) {
    },
    addConfirmClick(){
      if(this.contractDName.indexOf(" ") >= 0){
        this.$message.warning("合约名称不能含空格！");
        return
      }
      this.resData = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"addContract",
        station_id:this.stationD,
        name:this.contractDName,
        type:this.contractDType,
        start_date:this.startTimeD ? parseDateFilter(this.startTimeD, 'yyyy-MM-dd') : '',
        end_date:this.endTimeD ? parseDateFilter(this.endTimeD, 'yyyy-MM-dd') : '',
        file:this.file,
      };
      const formData = new FormData();
      formData.append("uid", this.resData.uid);
      formData.append("token", this.resData.token);
      formData.append("action", this.resData.action);
      formData.append("station_id", this.resData.station_id);
      formData.append("name", this.resData.name);
      formData.append("type", this.resData.type);
      formData.append("start_date", this.resData.start_date);
      formData.append("end_date", this.resData.end_date);
      formData.append('file', this.file);
      this.$api({
          method: "post",
          url: "/api.php/Contract/index",
          data: formData,
      })
          .then(su => {
              if(su.data.code == 1){
                this.$message.success(su.data.message);
                this.newContractDialog = false;
                this.provincesName = "";
                this.cityName = "";
                this.stationName = "";
                this.contractType = "";
                this.contractName = "";
                this.totalNum = 0;
                this.startnum = 0;
                this.endnum = 1;
                this.getDataList();
                this.provinceD = "";
                this.cityD = "";
                this.cityDList = [];
                this.stationD = "";
                this.stationDList = [];
                this.contractDName = "";
                this.contractDType = "";
                this.startTimeD = "";
                this.endTimeD = "";
                this.file = {};
                this.fileTitle = "未选择任何文件";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    provinceDChange(province){
      this.cityD = "";
      this.cityDList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cityDList = su.data.list;
              } else if(su.data.code == 300) {
                  localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cityDChange(city){
      this.stationDList = [];
      this.stationD = "";
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.stationDList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    stationDChange(stationId){
      this.stationD = stationId;
    },
    editClick(row,num){
      this.editId = row.id;
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"getContract",
          id:row.id,
      };
      this.$api({
          method: "post",
          url: "/api.php/Contract/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.btnNumber = num;
                this.newContractDialog = true;
                this.contractTitle = "编辑合约";
                this.getProvinces();
                let list = su.data.list;
                this.provinceD = list.province;
                this.cityD = list.city;
                // this.cityDList = [];
                this.stationD = list.station_name;
                // this.stationDList = [];
                this.contractDName = list.name;
                this.contractDType = list.type;
                this.startTimeD = list.start_date;
                this.endTimeD = list.end_date;
                // this.file = {};
                this.fileTitle = list.filename;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    editConfirmClick(){
      if(this.contractDName.indexOf(" ") >= 0){
        this.$message.warning("合约名称不能含空格！");
        return
      }
      this.resData = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"editContract",
        id:this.editId,
        name:this.contractDName,
        type:this.contractDType,
        start_date:this.startTimeD ? parseDateFilter(this.startTimeD, 'yyyy-MM-dd') : '',
        end_date:this.endTimeD ? parseDateFilter(this.endTimeD, 'yyyy-MM-dd') : '',
        file:this.file,
      };
      const formData = new FormData();
      formData.append("uid", this.resData.uid);
      formData.append("token", this.resData.token);
      formData.append("action", this.resData.action);
      formData.append("id", this.resData.id);
      formData.append("name", this.resData.name);
      formData.append("type", this.resData.type);
      formData.append("start_date", this.resData.start_date);
      formData.append("end_date", this.resData.end_date);
      formData.append('file', this.file);
      this.$api({
          method: "post",
          url: "/api.php/Contract/index",
          data: formData,
      })
          .then(su => {
              if(su.data.code == 1){
                this.$message.success(su.data.message);
                this.newContractDialog = false;
                this.getDataList(this.provincesName,this.cityName,this.stationName,this.contractType,this.contractName);
                this.provinceD = "";
                this.cityD = "";
                this.cityDList = [];
                this.stationD = "";
                this.stationDList = [];
                this.contractDName = "";
                this.contractDType = "";
                this.startTimeD = "";
                this.endTimeD = "";
                this.file = {};
                this.fileTitle = "未选择任何文件";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
  },
};
</script>

<style scoped lang="scss">
.contract-management {
  .contract-management-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076bc;
      margin-left: 20px;
      font-weight: 700;
    }
  }
  .contract-management-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 12px;
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 64px;
    .search-criteria {
      width: 98%;
      margin-left: 1%;
      .search-criteria-l {
        float: left;
        .el-select {
          float: left;
          margin-right: 10px;
        }
        .el-input {
          width: 15%;
          float: left;
          margin-right: 10px;
        }
        .search {
          float: left;
          background-color: #0071bd;
          border:none;
          color: #feffff;
        }
        .search:active {
          background-color: #409EFF;
        }
      }
      .search-criteria-r {
        float: right;
        .newly-build {
          background-color: #f15500;
          border:none;
          color: #feffff;
        }
        .newly-build.active {
          background-color: #a5a5a5;
        }
      }
    }
    .contract-table {
      width: 98%;
      margin-left: 1%;
      margin-top: 24px;
      .table-btn {
        width: 54px;
        height: 26px;
        padding: 0;
        background-color: #f15500;
        border:none;
        color: #feffff;
        margin-left: 5px;
        font-size: 12px;
      }
      .table-see {
        display: inline-block;
        width: 54px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border-radius: 4px;
        padding: 0;
        background-color: #f15500;
        border:none;
        color: #feffff;
        text-decoration: none;
        font-size: 12px;
      }
      .table-edit {
        background-color: #0071bd;
      }
      .table-delete {
        background-color: #00b270;
      }
      .table-see.active {
        background-color: #aaaaaa;
      }
      .table-edit.active {
        background-color: #aaaaaa;
      }
      .table-delete.active {
        background-color: #aaaaaa;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .new-contract-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
      margin-bottom: 30px;
    }
    .contract-content {
      .content-left {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            .star {
              color:#EE0002;
            }
          }
          .details-title.title-province {
            vertical-align: top;
            margin-top: 10px;
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
          .details-r.details-province {
            .el-select {
              float: left;
              width: 32.2%;
              margin-right: 1%;
            }
            .el-select:last-child {
              margin-right: 0;
            }
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
        }
      }
      .content-right {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            .star {
              color:#EE0002;
            }
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
            .el-date-editor.el-input {
              width: 100%;
            }
          }
          .upload-title {
            vertical-align: top;
            margin-top: 12px;
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
            .upload-text {
              width: 100%;
              height: 40px;
              border:1px solid #DCDFE6;
              border-radius: 4px;
              .upload-demo {
                float: left;
                margin-left: 6px;
                margin-top: 4px;
                .el-button--primary {
                  color: #9a9a9a;
                  background-color: #f7f7f7;
                  border-color: #b7b7b7;
                }
              }
              .file-name {
                float: left;
                width: 160px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 40px;
                margin-left: 6px;
                color: #999999;
              }
            }
          }
        }
      }
    }
    .button {
      margin-top: 20px;
      .button-cancel {
        width: 26%;
        height: 50px;
        background-color: #0071BD;
        border:none;
        color:#ffffff;
      }
      .button-confirm {
        width: 26%;
        height: 50px;
        background-color: #02B36F;
        border:none;
        color:#ffffff;
      }
    }
  }
}
@media screen and (max-width:1400px) {
  .contract-management {
    .contract-management-bottom {
      .search-criteria {
        .search-criteria-l {
          width: 70%;
          .el-select {
            width: 15%;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.contract-management .el-table--enable-row-hover .el-table__body tr:hover>td .table-edit {
  background-color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/taskManagement.vue